import * as Xxhash from './xxhash'

export const encodeSubstrateStorageKey = Xxhash.encodeSubstrateStorageKey

export {Xxhash}
